import BBHCFoundersVideo from "../IIN/BBHCFoundersVideo"
import BusinessBootcampVideo1 from "../businessbootcamp/BusinessBootcampDuoVideo"

interface Props {
  isBootcamp?: boolean
}

const Message: React.FC<Props> = ({ isBootcamp }) => {
  return (
    <div className="">
      {isBootcamp ? (
        <div
          className="flex flex-col lg:flex-row items-center justify-between w-full h-auto xlg:px-0 py-[56px] md:py-[96px] gap-16 mx-auto md:px-[144px] px-4 sm:px-8 max-w-screen-xl mx-auto"
          style={{ fontFamily: "BeausiteClassic" }}
        >
          {/* Left Section - Title and Text */}
          <div className="flex flex-col gap-6 text-left">
            <h2
              className="text-black text-[48px] font-bold leading-tight"
              style={{ lineHeight: "1.2" }}
            >
              A Message from the Creators of this Training
            </h2>

            <div
              className="text-black font-normal"
              style={{ fontSize: "21px", lineHeight: "26.4px" }}
            >
              <p>
                Hear from Nichole Lowe, Founder and CEO of Zoee, and Zack
                Bodenweber, NBC-HWC, LMSW, BCC, ACC, Coaching Entrepreneur and
                Educator, on why this bootcamp is the premier training for
                coaches who want to build sustainable, prosperous businesses
                they actually love.
              </p>
              <p className="mt-4">
                This program was designed from the inside out from two people
                who understand this world better than anyone:
              </p>

              <div className="flex flex-col lg:flex-row gap-8 mt-6">
                {/* Bullet Points */}
                <div className="flex-1 p-4">
                  <ul className="list-disc list-inside space-y-4">
                    <li>
                      <span className="font-bold">Nichole</span> brings her
                      pioneering vision of creating wealth and opportunity for
                      coaches everywhere, combined with her experience leading
                      industry innovation and building Zoee’s platform of
                      cutting-edge tools to simplify running your practice.
                    </li>
                    <li>
                      <span className="font-bold">Zack</span> brings over a
                      decade of experience as a coach, entrepreneur, and guide
                      to thousands of coaches worldwide, with a focus on helping
                      you cut through the noise and build what actually works in
                      a way that’s authentic and aligned.
                    </li>
                  </ul>
                </div>

                {/* Video */}
                <div className="flex-1 p-4 flex justify-center items-center">
                  {isBootcamp ? (
                    <BusinessBootcampVideo1 />
                  ) : (
                    <BBHCFoundersVideo />
                  )}
                </div>
              </div>

              <p className="mt-6">
                Together, their mission is clear:{" "}
                <span className="font-bold">
                  support and empower coaches, so coaches can support and
                  empower the world.
                </span>
              </p>
              <br />
              <p>
                Not sure if you’re ready to join the bootcamp yet?{" "}
                <span className="font-bold">
                  Join Zack for an upcoming webinar on January 7, 2026 at 1pm ET{" "}
                </span>
                where he’ll give you a preview of what to expect in the
                Bootcamp.{" "}
                <a
                  href="https://us02web.zoom.us/webinar/register/WN_lAXNrn1nTYG-yuOLjz9RzQ#/registration"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text-blurple font-bold">
                    {" "}
                    Register today!
                  </span>
                </a>
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div
          className="flex flex-col lg:flex-row items-center justify-between w-full h-auto xlg:px-0 py-[56px] md:py-[96px] gap-16 mx-auto md:px-[144px] px-4 sm:px-8 max-w-screen-xl mx-auto"
          style={{ fontFamily: "BeausiteClassic" }}
        >
          {/* Left Section - Title and Text */}
          <div className="flex flex-col gap-6 lg:w-2/3 text-left">
            <h2
              className="text-black text-[48px] font-bold leading-tight"
              style={{
                lineHeight: "1.2",
              }}
            >
              A message from Our CEOs
            </h2>

            <p
              className="text-black font-normal"
              style={{
                fontSize: "21px",
                lineHeight: "26.4px",
              }}
            >
              <p>
                Hear from Nichole Lowe, founder and CEO of Zoee, and Nora
                McCaffrey, MSEd, CEO of the Institute for Integrative Nutrition,
                on why this program is the premier solution for Health Coaches
                seeking the education and technology to build or scale their
                online coaching businesses with efficiency and ease.
              </p>
            </p>
          </div>

          {/* Right Section - Video */}
          <div className="w-full lg:w-1/2 aspect-w-16 aspect-h-9 bg-[#d9d9d9] rounded-lg overflow-hidden max-w-[600px] max-h-[400px]">
            {isBootcamp ? <BusinessBootcampVideo1 /> : <BBHCFoundersVideo />}
          </div>
        </div>
      )}
    </div>
  )
}

export default Message
